export const frontmatter = {
    "draft": true,
    "title": "SDK de Python",
    "description": "Librería oficial de OnnIA para interactuar con canales, ejecutar workflows e integrar agentes inteligentes desde aplicaciones de Python.",
    "sidebar_label": "Python",
    "sidebar_group": "referencia",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "instalacion",
        "value": "Instalación"
    },
    {
        "depth": 2,
        "id": "inicializacion",
        "value": "Inicialización"
    },
    {
        "depth": 2,
        "id": "ejemplos-de-uso",
        "value": "Ejemplos de uso"
    },
    {
        "depth": 3,
        "id": "enviar-mensajes",
        "value": "Enviar mensajes"
    },
    {
        "depth": 3,
        "id": "iniciar-un-workflow",
        "value": "Iniciar un Workflow"
    }
]